import { createTextVNode as t } from "vue";
const o = (e, ...n) => typeof e == "function" ? e(...n) : typeof e == "string" ? t(e) : typeof e == "number" ? t(String(e)) : null;
export {
  o as render
};
